import React, { useContext } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import { usePortalNode } from '../hooks/usePortalNode';
import { PopupContext } from '../../popups/PopupContext';
import s from './PopperPortal.scss';
/** Simple wrapper to stick things into a portal */ const PopperPortal = ({ portalClassName, children })=>{
    const { isInPopup } = useContext(PopupContext);
    const portalContainer = usePortalNode('popper', classnames(isInPopup ? s['popup-portal'] : s['portal'], 'popper-portal', portalClassName));
    return portalContainer && /*#__PURE__*/ ReactDOM.createPortal(children, portalContainer);
};
PopperPortal.displayName = 'PopperPortal';
export default PopperPortal;

//# sourceMappingURL=PopperPortal.js.map